import { motion } from "framer-motion";
import { Building2, Sun, Route, Waypoints, Network, Zap, ArrowUpLeft } from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";
import { useLang } from "../context/LangContext";

const ICONS = { roads: Route, bridges: Waypoints, water: Network, buildings: Building2, solar: Sun, mep: Zap };

export default function Services() {
  const { t } = useLang();
  return (
    <section id="services" data-testid="services-section" className="relative py-20 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeader
          index={t.services.index}
          eyebrow={t.services.eyebrow}
          title={t.services.title}
          description={t.services.desc}
        />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[s.id];
            return (
              <Reveal key={s.id} delay={i * 0.08} className={s.span}>
                <motion.div
                  data-testid={`service-card-${s.id}`}
                  whileHover={{ y: -8 }}
                  transition={{ type: "spring", stiffness: 300, damping: 22 }}
                  className="group relative h-full rounded-lg border border-[#E8DFC5] bg-white p-8 lg:p-10 overflow-hidden transition-colors duration-300 hover:border-emerald-500/50 hover:bg-[#F5EEDC]"
                >
                  <div className="absolute -top-16 -left-16 w-40 h-40 rounded-full bg-emerald-500/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <div className="flex items-start justify-between mb-8">
                    <span className="w-14 h-14 rounded-md bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center transition-colors duration-300 group-hover:bg-emerald-500">
                      <Icon className="w-7 h-7 text-emerald-600 transition-colors duration-300 group-hover:text-white" strokeWidth={1.8} />
                    </span>
                    <ArrowUpLeft className="w-5 h-5 text-stone-400 transition-all duration-300 group-hover:text-emerald-600 group-hover:-translate-y-1 group-hover:translate-x-1" />
                  </div>
                  <h3 className="font-heading font-bold text-xl sm:text-2xl text-stone-900 mb-4">
                    {s.title}
                  </h3>
                  <p className="text-base leading-relaxed text-stone-500">{s.desc}</p>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
